
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "vue-property-decorator";
import { BgInputNumber } from "@banggood/scm-fe";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import { ElementUIFormRules } from "@/service/supplier-meta/common/supplier-field-ctrl";
import { Form } from "element-ui";
@Component({
  components: {
    BgInputNumber,
  },
})
export default class OaClothingFgb extends SupplierForm {
  form = {
    factoryInfo: {
      developmentInfo: {
        productPriceRange: "",
        newQuantityMonth: null as number | null,
        isForeignFashion: false,
        printingQuantityMonth: null as number | null,
      },
    },
  };
  get rules(): ElementUIFormRules {
    return this.getFieldsRules([
      "factoryInfo.developmentInfo.productPriceRange",
      "factoryInfo.developmentInfo.newQuantityMonth",
      "factoryInfo.developmentInfo.isForeignFashion",
      "factoryInfo.developmentInfo.printingQuantityMonth",
    ]);
  }
  getFormRef() {
    return this.$refs.form as Form;
  }
  getFormData() {
    return {
      ...this.form,
    };
  }
}
